export default "__VITE_ASSET__cdLoc1rQ__"